import React from 'react';
import { FieldGroup } from '@ver-uds/react';
import { useUser } from '../../../context/User/UserContext';

// This is separated from BaseEVerifyUsersReview to avoid using useUser without the UserProvider during MFA Enrollment
const PointOfContact = (): JSX.Element => {
  const user = useUser();

  const pointOfContact = user?.email;

  return (
    <FieldGroup.Field className="tablet:grid-col-6" name="Enrollment Point of Contact">
      {pointOfContact}
    </FieldGroup.Field>
  );
};

export default PointOfContact;
